
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import draggable from 'vuedraggable';
    import { mapState } from 'vuex';
    import { ValidationRules } from '@/store/types';
    import Folgeimpfstoff from '@/types/Folgeimpfstoff';
    import Impfstoff from '@/types/Impfstoffe';

    enum SwapDirection {
        Up,
        Down,
    }

    @Component({
        components: {
            draggable,
        },
        computed: {
            ...mapState('globals', ['rules']),
        },
    })
    export default class ImpfstoffeFolgeimpfstoffe extends Vue {
        @Prop() folgeimpfstoffe!: Folgeimpfstoff[];
        @Prop() impfstoffe!: Impfstoff[];
        @Prop() loading!: boolean;
        @Prop() impfstoffError!: boolean;

        public $refs!: {
            folgeimpfstoffe: Vue;
        };

        public rules!: ValidationRules[];

        public draggedFolgeimpfstoffe: Folgeimpfstoff[] = [];
        public temp_folgeimpfstoff_id = -1;

        public get impfstoffClass(): string {
            return this.impfstoffError ? ' error--text' : '';
        }

        public mounted(): void {
            this.temp_folgeimpfstoff_id = -1;
        }

        public get tableHeight(): string | undefined {
            const count = this.folgeimpfstoffe?.length;
            return count > 10 ? '400px' : undefined;
        }

        @Watch('folgeimpfstoffe.length')
        public onChangeFolgeImpfstoffe(): void {
            this.draggedFolgeimpfstoffe = [...this.folgeimpfstoffe];
        }

        public onChangeDraggedFolgeimpfstoffe(): void {
            const reordered = this.draggedFolgeimpfstoffe.map((impfstoff, index) => {
                impfstoff.ordernumber = index + 1;
                return impfstoff;
            });
            this.folgeimpfstoffe.splice(0, this.folgeimpfstoffe.length, ...reordered);
        }

        public onClickAdd(): void {
            this.folgeimpfstoffe.push(new Folgeimpfstoff({
                folgeimpfstoff_id: this.temp_folgeimpfstoff_id--,
                ordernumber: this.folgeimpfstoffe.length + 1,
            }));

            this.$nextTick(() => {
                const table = this.$refs.folgeimpfstoffe.$el.firstElementChild;
                if (table) {
                    table.scrollTop = table.scrollHeight;
                }
            });
        }

        public onClickDeleteAll(): void {
            this.folgeimpfstoffe.splice(0, this.folgeimpfstoffe.length);
        }

        public onClickMoveUp(folgeimpfstoff: Folgeimpfstoff): void {
            this.swap(folgeimpfstoff, SwapDirection.Up);
        }

        public onClickMoveDown(folgeimpfstoff: Folgeimpfstoff): void {
            this.swap(folgeimpfstoff, SwapDirection.Down);
        }

        public swap({ folgeimpfstoff_id }: Folgeimpfstoff, direction: SwapDirection): void {
            const byId = (folgeimpfstoff: Folgeimpfstoff): boolean => {
                return folgeimpfstoff.folgeimpfstoff_id === folgeimpfstoff_id;
            };

            const count = direction === SwapDirection.Down ? 1 : -1;
            const index = this.folgeimpfstoffe.findIndex(byId);

            const [toSwap] = this.folgeimpfstoffe.splice(index, 1);
            this.folgeimpfstoffe.splice(index + count, 0, toSwap);
            this.folgeimpfstoffe.forEach((impfstoff, index) => impfstoff.ordernumber = index + 1);

            this.onChangeFolgeImpfstoffe();
        }

        public onClickDelete(folgeimpfstoff: Folgeimpfstoff): void {
            const index = this.folgeimpfstoffe.indexOf(folgeimpfstoff);
            this.folgeimpfstoffe.splice(index, 1);
            this.folgeimpfstoffe.forEach((impfstoff, index) => impfstoff.ordernumber = index + 1);
        }
    }
